export default __webpack_public_path__ + "7f4d23bfac22d8294b9347965408ebfd.svg";